export const wrapCDN = (id: string, width: number) =>
    process.env.imgDomain +
    `/tikmeta/${id}?imageMogr2/auto-orient/thumbnail/${width}x/strip/format/WEBP/quality/75!/ignore-error/1`;

export const countryIcon = (countryCode: string, width = 60) => {
    return (
        process.env.imgDomain +
        `/flag/${countryCode}.png?imageMogr2/auto-orient/thumbnail/${width}x/strip/format/WEBP/quality/75!/ignore-error/1`
    );
};

export const wrapGoodCDN = (id: string, width: number) =>
    process.env.imgDomain +
    `/product/${id}?imageMogr2/auto-orient/thumbnail/${width}x/strip/format/WEBP/quality/75!/ignore-error/1`;
